"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M2.598 10.422a1.992 1.992 0 0 0 0 3.157l8.19 6.304c1.31 1.008 3.207.075 3.207-1.579V5.696c0-1.653-1.898-2.587-3.208-1.579zM22.18 5.2a1.5 1.5 0 0 0-1.5-1.5h-2.188a1.5 1.5 0 0 0-1.5 1.5v13.6a1.5 1.5 0 0 0 1.5 1.5h2.187a1.5 1.5 0 0 0 1.5-1.5z"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=StepBackwardIcon24.js.map